import { gql } from "@apollo/client";

export const getWSPayPaymentDetails = gql`
query GetWSPayPaymentData($id: String!, $input: GetWspayPaymentDataInput!) {
  getWSPayPaymentData(id: $id, input: $input) {
    ShopID
    ShoppingCartID
    TotalAmount
    Signature
    ReturnURL
    CancelURL
    ReturnErrorURL
    PaymentPlan
    CustomerFirstName
    CustomerLastName
    CustomerAddress
    CustomerCity
    CustomerZIP
    CustomerCountry
    CustomerPhone
    CustomerEmail
    PaymentMethod
    Iframe
    IframeResponseTarget
    Version
  }
}`